import { render, staticRenderFns } from "./PageSeven.vue?vue&type=template&id=48bdef2e&scoped=true&"
import script from "./PageSeven.vue?vue&type=script&lang=js&"
export * from "./PageSeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdef2e",
  null
  
)

export default component.exports